// Frontegg constants
export const fronteggBaseUrl = process.env.REACT_APP_FRONTEGG_BASE_URL || 'https://auth-dev.ask-ai.co';
export const fronteggClientId = process.env.REACT_APP_FRONTEGG_CLIENT_ID || '9857bef1-5217-40d4-9a65-fb2befc57f01';

export const APP_BASENAME = process.env.REACT_APP_BASENAME || '';
